var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCopy(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.4026 15.1663H4.6026C1.99594 15.1663 0.835938 14.0063 0.835938 11.3997V8.59967C0.835938 5.99301 1.99594 4.83301 4.6026 4.83301H7.4026C10.0093 4.83301 11.1693 5.99301 11.1693 8.59967V11.3997C11.1693 14.0063 10.0093 15.1663 7.4026 15.1663ZM4.6026 5.83301C2.53594 5.83301 1.83594 6.53301 1.83594 8.59967V11.3997C1.83594 13.4663 2.53594 14.1663 4.6026 14.1663H7.4026C9.46927 14.1663 10.1693 13.4663 10.1693 11.3997V8.59967C10.1693 6.53301 9.46927 5.83301 7.4026 5.83301H4.6026Z",
    fill: "#0E1B28"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4026 11.1663H10.6693C10.3959 11.1663 10.1693 10.9397 10.1693 10.6663V8.59967C10.1693 6.53301 9.46927 5.83301 7.4026 5.83301H5.33594C5.0626 5.83301 4.83594 5.60634 4.83594 5.33301V4.59967C4.83594 1.99301 5.99594 0.833008 8.6026 0.833008H11.4026C14.0093 0.833008 15.1693 1.99301 15.1693 4.59967V7.39967C15.1693 10.0063 14.0093 11.1663 11.4026 11.1663ZM11.1693 10.1663H11.4026C13.4693 10.1663 14.1693 9.46634 14.1693 7.39967V4.59967C14.1693 2.53301 13.4693 1.83301 11.4026 1.83301H8.6026C6.53594 1.83301 5.83594 2.53301 5.83594 4.59967V4.83301H7.4026C10.0093 4.83301 11.1693 5.99301 11.1693 8.59967V10.1663Z",
    fill: "#292D32"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.f5a87e22.svg";
export { ForwardRef as ReactComponent };